module.exports = __webpack_public_path__ + "img/kefulogo.e318c4d1.jpg";